import { ServiceItem } from './ServiceItem'
import { IServiceProps } from './types'
import './Services.scss'
import { useMemo } from 'react'
import { __ } from '@wordpress/i18n'
import { useBookingContext } from '../../providers/BookingFormProvider/BookingFormProvider'
import { useWording } from '../../hooks/useWording'

export const Services = () => {
    const wording = useWording()
    const { services, categories, attrCategory, preset, extractedAttrCats } =
        useBookingContext()
    const selectedCategory = useMemo(
        () =>
            categories.find(
                ({ selected, id }) => selected || id === Number(attrCategory)
            ),
        [categories]
    )

    const servicesToView = useMemo(() => {
        // if there is no category defined in shortcode attribute
        if (extractedAttrCats.length === 0 && !selectedCategory) return services

        // if there is a category defined and at least one category is selected by user
        if (selectedCategory) {
            return services.filter(({ id }) => {
                return selectedCategory.services.includes(String(id))
            })
        }

        // if there is a category defined but no category is selected
        if (extractedAttrCats.length > 0 && !selectedCategory) {
            return services.filter(({ id }) => {
                const definedCategoriesServices = categories
                    .filter((c) => extractedAttrCats.includes(Number(c.id)))
                    .map(({ services }) => services)

                return definedCategoriesServices.flat().includes(String(id))
            })
        }
    }, [selectedCategory, services])

    if (!preset || !preset.services) {
        return (
            <div className="wbk_services_wrapper">
                {[...Array(5)].map((_, i) => (
                    <div key={i} className="wbk_services_skeleton" />
                ))}
            </div>
        )
    }

    return (
        <div className="wbk_services_wrapper">
            {servicesToView &&
                servicesToView.map((service: IServiceProps, index: number) => (
                    <div
                        key={index}
                        className="wbk_services_item_appear"
                        style={{ animationDelay: `${index * 80}ms` }}
                    >
                        <ServiceItem {...service} />
                    </div>
                ))}
            {!servicesToView ||
                (servicesToView.length === 0 && (
                    <p>
                        {wording.no_services_found ||
                            __('No services found!', 'webba-booking-lite')}
                    </p>
                ))}
        </div>
    )
}
